import {
  Button,
  TextField,
  DialogActions,
  DialogTitle,
  MenuItem,
} from "@mui/material";
import ShowFullScreenBackdrop from "components/ShowFullScreenBackdrop";
import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addAdminUser, updateAdminUser } from "service/users/AdminUsers";

const AdminUsersForm = ({ handleClose, handleData, fetchAdminUserList }) => {
  const [fullName, setFullName] = useState(handleData?.fullName || "");
  const [email, setEmail] = useState(handleData?.email || "");
  const [password, setPassword] = useState(handleData?.password || "");
  const [role, setRole] = useState(handleData?.role || "");
  const [open, setOpen] = useState(false);
  const adminUserId = handleData?._id;

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    const userAddData = {
      fullName,
      email,
      password,
      role,
    };

    const userUpdateData = {
      fullName,
      email,
      role,
    };

    try {
      setOpen(true);
      let response;
      if (adminUserId) {
        response = await updateAdminUser(userUpdateData, adminUserId);
      } else {
        response = await addAdminUser(userAddData);
      }

      if (response.status === 200 || response.status === 201) {
        handleClose();
        await fetchAdminUserList();
        const successMessage = adminUserId
          ? "User updated successfully!"
          : "User added successfully!";
        toast.success(successMessage);
        setOpen(false);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error(
          `Failed to ${adminUserId ? "update" : "add"} the user. Please try again.`
        );
      }
    } finally {
      setOpen(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <DialogTitle sx={{ fontSize: "18px", fontWeight: "600" }}>
        {adminUserId ? "UPDATE ADMIN USER" : "ADD ADMIN USER"}
      </DialogTitle>
      <form onSubmit={handleFormSubmit}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            padding: "1rem",
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            type="text"
            label="Full Name"
            name="fullName"
            color="secondary"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            sx={{ margin: "1rem", width: "calc(100% - 1rem)" }}
            required
          />

          <TextField
            fullWidth
            variant="outlined"
            type="email"
            label="Email"
            name="email"
            color="secondary"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ margin: "1rem", width: "calc(100% - 1rem)" }}
            required
          />
          {!adminUserId ? (
            <TextField
              fullWidth
              variant="outlined"
              type="password"
              label="Password"
              name="password"
              color="secondary"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ margin: "1rem", width: "calc(100% - 1rem)" }}
              required
            />
          ) : null}

          <TextField
            labelid="role"
            id="role"
            select
            label="Role"
            color="secondary"
            value={role}
            required
            onChange={(e) => setRole(e.target.value)}
            sx={{ margin: "1rem", width: "calc(100% - 1rem)" }}
          >
            <MenuItem value={1}>Super Admin</MenuItem>
            <MenuItem value={2}>Admin</MenuItem>
            <MenuItem value={3}>Manager</MenuItem>
            <MenuItem value={4}>Staff</MenuItem>
          </TextField>
        </div>
        <DialogActions>
          <Button
            variant="contained"
            sx={{ margin: "1em" }}
            color="error"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            type="submit"
            color="info"
            sx={{ margin: "1rem" }}
          >
            {adminUserId ? "Update User" : "Add User"}
          </Button>
        </DialogActions>
      </form>
      {open && <ShowFullScreenBackdrop open={open} />}
    </>
  );
};

export default AdminUsersForm;
